import React from 'react';
import { Grid, Box, Button, CircularProgress } from '@mui/material';
import { FormSection, SectionTitle } from './StyledComponents';
import DocumentDrop from '../../../InventoryManagement/DocumentDrop';

const OCRSection = ({
    autoFilling,
    direction,
    t,
    importManifestDocuments,
    setImportManifestDocuments,
    handleImportManifestDocumentUpload,
    customsAgentInvoiceDocuments,
    setCustomsAgentInvoiceDocuments,
    handleCustomsAgentInvoiceDocumentUpload,
    isProcessingImportManifestOCR,
    isProcessingCustomsAgentInvoiceOCR,
    handleProcessOCR,
    handleProcessCustomsAgentInvoiceOCR
}) => {
    if (!autoFilling) return null;

    return (
        <FormSection dir={direction}>
            <SectionTitle dir={direction}>{t('AutoUploading')}</SectionTitle>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Box sx={{ fontWeight: '600', fontSize: '0.875rem', color: '#666666', mb: 0.5 }}>
                            {t('ImportManifestDetails')}
                        </Box>
                        <DocumentDrop
                            documents={importManifestDocuments}
                            setDocuments={setImportManifestDocuments}
                            handleDocumentUpload={handleImportManifestDocumentUpload}
                            autoFilling={autoFilling}
                        />
                        {importManifestDocuments.length > 0 && (
                            <Button
                                variant="contained"
                                onClick={handleProcessOCR}
                                disabled={isProcessingImportManifestOCR}
                                startIcon={isProcessingImportManifestOCR ? <CircularProgress size={20} color="inherit" /> : null}
                                sx={{
                                    backgroundColor: '#304FFF',
                                    '&:hover': { backgroundColor: '#1a237e' },
                                    '&:disabled': { backgroundColor: '#ccc' }
                                }}
                            >
                                {isProcessingImportManifestOCR ? t('Processing') : t('ProcessDocument')}
                            </Button>
                        )}
                    </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Box sx={{ fontWeight: '600', fontSize: '0.875rem', color: '#666666', mb: 0.5 }}>
                            {t('CustomsAgentInvoice')}
                        </Box>
                        <DocumentDrop
                            documents={customsAgentInvoiceDocuments}
                            setDocuments={setCustomsAgentInvoiceDocuments}
                            handleDocumentUpload={handleCustomsAgentInvoiceDocumentUpload}
                            autoFilling={autoFilling}
                        />
                        {customsAgentInvoiceDocuments.length > 0 && (
                            <Button
                                variant="contained"
                                onClick={handleProcessCustomsAgentInvoiceOCR}
                                disabled={isProcessingCustomsAgentInvoiceOCR}
                                startIcon={isProcessingCustomsAgentInvoiceOCR ? <CircularProgress size={20} color="inherit" /> : null}
                                sx={{
                                    backgroundColor: '#307bf2',
                                    '&:hover': { backgroundColor: '#307bf2', color: '#fff' },
                                    '&:disabled': { backgroundColor: '#ccc' }
                                }}
                            >
                                {isProcessingCustomsAgentInvoiceOCR ? t('Processing') : t('ProcessCustomsAgentInvoice')}
                            </Button>
                        )}
                    </Box>
                </Grid>
            </Grid>
        </FormSection>
    );
};

export default OCRSection;